<template>
    <b-dropdown class="dropdown-search" :text="String(selectedElement)" variant="secondary" ref="dropDownSearch">
        <b-dropdown-header v-if="isSearch" class="dropdown_search_search" >
            <b-form-input type="text" class="form-control input-search" @input="search()" v-model="searchPhrase"/>
            <svg-icon name="search"/>
        </b-dropdown-header>
        <div class="dropdown_elements dropdown_search_elements">
            <b-dropdown-item v-if="showEmpty" v-on:click="selectElement(null)">Brak</b-dropdown-item>
            <b-dropdown-item v-for="element in filteredElements" v-on:click="selectElement(element)">
                {{ getLabel(element) }}
            </b-dropdown-item>
        </div>
    </b-dropdown>
</template>

<script>
  import translation from './../../utils/translation'

  export default {
    props: {

      elements: {
        default: ''
      },
      isSearch: {
        type: Boolean,
        default: false
      },
      emptyValue: {
        type: String,
        default: 'Wybierz'
      },
      showEmpty: {
        type: Boolean,
        default: false
      },
      value: null,
      valueField: null,
      nameField: null,

    },
    methods: {
      setSelectedElement () {
        if (this.value != '' && this.value != null) {
          this.selectedElement = this.getLabel(this.searchSelectedElement(this.value))
        } else {
          this.selectedElement = this.emptyValue
        }
      },
      getLabel (element) {
        if(element != null){
          if (this.nameField != null) {
            return translation.translate(element[this.nameField])
          }
          return translation.translate(element)
        }
      },
      selectElement (element) {
        if (element == null) {
          this.$emit('input', element)
          this.$emit('change', element)
          this.selectedElement = this.emptyValue
          return this.selectedElement
        }
        this.selectedElement = this.getLabel(element)
        if (this.valueField != null) {
          this.$emit('input', element[this.valueField])
        } else {
          this.$emit('input', element)
        }
        this.$emit('change', element)
        return this.selectedElement
      },
      search () {
        if (this.searchPhrase != null) {
          this.filteredElements = this.elements.filter((object) => {
            return object[this.nameField].toLowerCase().indexOf(this.searchPhrase.toLowerCase()) >= 0 ? true : false
          })
        }
        else {
          this.filteredElements = this.elements
        }
        if(this.$refs.dropDownSearch._popper){
          this.$refs.dropDownSearch._popper.scheduleUpdate()
        }
      },
      searchSelectedElement (value) {
        if (this.valueField != null && value[this.valueField] != undefined) {
          value = value[this.valueField]
        }
        for (let index = 0; index < this.elements.length; index++) {
          let element = this.elements[index]
          let valueInElement = null
          if (this.valueField != null) {
            valueInElement = element[this.valueField]
          }
          else {
            valueInElement = element
          }
          if (valueInElement == value || (valueInElement.id == value.id && valueInElement.id != undefined )) {
            return element
          }
        }
      }
    },
    data () {
      return {
        selectedElement: this.emptyValue,
        filteredElements: this.elements,
        searchPhrase: null
      }
    },
    created () {
      this.setSelectedElement()
    },
    watch: {
      elements: function () {
        this.search()
        this.setSelectedElement()
      },
      value: function () {
        this.setSelectedElement()
      }

    }
  }
</script>

<style lang="scss">
    @import './../../assets/styles/_style.scss';

    .dropdown-search.show .dropdown-menu {
        display: flex;
        flex-direction: column;
    }

    .dropdown_search_search {
        order: 1;
    }

    .dropdown-menu[x-placement='top-start'] .dropdown_search_search {
        order: 3;
    }
    .dropdown_search_elements {
        order: 2;
    }
</style>


// WEBPACK FOOTER //
// DropdownSearch.vue?e9fa6cb8